export default "__VITE_ASSET__BJJA5x_h__"